import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import { Provider } from 'react-redux'
import store from '../../store/'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

// SENTRY
import * as Sentry from '@sentry/browser'
import { I18nextProvider } from 'react-i18next'
import i18next from '../../translations/i18n'

// THEME
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import muiTheme from '../../theme/muiTheme'
import { SnackbarProvider } from 'notistack'

// COMPONENTS
import Logger from '../../pages/Logger'
import Home from '../../pages/Home'
import Login from '../../pages/Login'
import Help from '../../pages/Help'
import Register from '../../pages/Register'
import RegisterV2 from '../../pages/RegisterV2'
import Dashboard from '../../pages/Dashboard'
import Verify from '../../pages/Verify'
import Site from '../../pages/Site'
import AddGa from '../../pages/AddGA'
import AddGa2 from '../../pages/AddGA2'
import GaUser from '../../pages/GaUser'
import GaUser2 from '../../pages/GaUser2'
import DataSet from '../../pages/Dataset'
import DataSet2 from '../../pages/Dataset2'
import Confirm from '../../pages/Confirm'
import Confirm2 from '../../pages/Confirm2'
import GAAsync from '../../pages/GAAsync'
import GAAsync2 from '../../pages/GAAsync2'
import SourceSetting from '../../pages/SourceSetting'
import CrmSetting from '../../pages/CrmSetting'
import CalltrackingSetting from '../../pages/CalltrackingSetting'
import StatisticsPage from '../../pages/Statistics'
import GaCompleted from '../../pages/GaCompleted'
import Sources from '../../pages/Sources'
import DashBoardStatistics from '../../pages/DashBoardStatistics'
import Profile from '../../pages/Profile'
import Crm from '../../pages/Crm'
import Calltracking from '../../pages/Calltracking'
import Chat from '../../pages/Chat'
import AmoCrm from '../../pages/AmoCrm'
import AmoCrmFinish from '../../pages/AmoCrmFinish'
import Comagic from '../../pages/Comagic'
import ComagicFinish from '../../pages/ComagicFinish'
import Bitrix24 from '../../pages/Bitrix24'
import Bitrix24Finish from '../../pages/Bitrix24Finish'
import RetailCrm from '../../pages/RetailCrm'
import RetailCrmFinish from '../../pages/RetailCrmFinish'
import EnvyCrm from '../../pages/EnvyCrm'
import EnvyCrmFinish from '../../pages/EnvyCrmFinish'
import UonCrm from '../../pages/UonCrm'
import UonCrmFinish from '../../pages/UonCrmFinish'
import Bitrix from '../../pages/Bitrix'
import BitrixFinish from '../../pages/BitrixFinish'
import CustomCrm from '../../pages/CustomCrm'
import CustomCrmFinish from '../../pages/CustomCrmFinish'
import GoogleAdsSetting from '../../pages/GoogleAdsSetting'
import VkontakteSetting from '../../pages/VkontakteSetting'
import CriteoSetting from '../../pages/CriteoSetting'
import CriteoSourceSetting from '../../pages/CriteoSourceSetting'
import VkontakteSourceSetting from '../../pages/VkontakteSourceSetting'
import GoogleAdsSourceSetting from '../../pages/GoogleAdsSourceSetting'
import GoogleAdsSourceConfirm from '../../pages/GoogleAdsSourceConfirm'
import YandexMarketSetting from '../../pages/YandexMarketSetting'
import YandexDirectSetting from '../../pages/YandexDirectSetting'
import MyTargetSetting from '../../pages/MyTargetSetting'
import MyTargetSourceSetting from '../../pages/MyTargetSourceSetting'
import DinremSetting from '../../pages/DinremSetting'
import YandexMarketSourceSetting from '../../pages/YandexMarketSourceSetting'
import YandexDirectSourceSetting from '../../pages/YandexDirectSourceSetting'
import DinremSourceSetting from '../../pages/DinremSourceSetting'
import Ecom from '../../pages/Ecom'
import FacebookSetting from '../../pages/FacebookSetting'
import FacebookSourceSetting from '../../pages/FacebookSourceSetting'
import EmailPass from '../../pages/EmailPass'
import PassReset from '../../pages/PassReset'
import PayVerify from '../../pages/PayVerify'
import Card from '../../pages/Card'
import CardComplete from '../../pages/CardComplete'
import CardFail from '../../pages/CardFail'
import Report from '../../pages/Report'
import Referral from '../../pages/Referral'
import ReportEndToEndDemo from '../../pages/ReportEndToEndDemo'
import ReportDailyDemo from '../../pages/ReportDailyDemo'
import MegaPlan from "../../pages/MegaPlan";
import MegaPlanFinish from "../../pages/MegaPlanFinish";
import Yclients from "../../pages/Yclients";
import YclientsFinish from "../../pages/YclientsFinish";
import CallTrackingBy from "../../pages/CallTrackingBy";

// STYLES
import withAppStyles from './App.style'

Sentry.init({
  dsn: 'https://1c897da6b5dc46f2ad3708a86204eae9@sentry.io/1907068',
})
Sentry.configureScope(function(scope) {
  scope.setUser({ email: window.state.user ? window.state.user.email : '' })
})

const App = withAppStyles(({ classes }) => (
  <div className={classes.App}>
    <CssBaseline />

    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/join/login" component={Login} />
      <Route path="/join" component={RegisterV2} />
      <Route path="/ga" component={GaCompleted} exact />
      <Route path="/help/:topic?" component={Help} />
      <Route path="/dashboard" component={Dashboard} />
      <Route exact path="/sources" component={Sources} />
      <Route path="/statistics" component={DashBoardStatistics} />
      <Route path="/profile" component={Profile} />
      <Route exact path="/calltracking" component={Calltracking} />
      <Route exact path="/calltracking/comagic" component={Comagic} />
      <Route exact path="/calltracking/comagic/create" component={Comagic} />
      <Route
        exact
        path="/calltracking/comagic/finish"
        component={ComagicFinish}
      />
      <Route exact path="/calltracking/call_tracking_by/create" component={CallTrackingBy}/>
      <Route exact path="/chat" component={Chat} />
      <Route exact path="/crm" component={Crm} />
      <Route exact path="/crm/amo" component={AmoCrm} />
      <Route exact path="/crm/amo/create" component={AmoCrm} />
      <Route exact path="/crm/amo/finish" component={AmoCrmFinish} />
      <Route exact path="/crm/bitrix24" component={Bitrix24} />
      <Route exact path="/crm/bitrix24/create" component={Bitrix24} />
      <Route exact path="/crm/bitrix24/finish" component={Bitrix24Finish} />
      <Route exact path="/crm/retail" component={RetailCrm} />
      <Route exact path="/crm/retail/create" component={RetailCrm} />
      <Route exact path="/crm/retail/finish" component={RetailCrmFinish} />
      <Route exact path="/crm/envy" component={EnvyCrm} />
      <Route exact path="/crm/envy/create" component={EnvyCrm} />
      <Route exact path="/crm/envy/finish" component={EnvyCrmFinish} />
      <Route exact path="/crm/uon" component={UonCrm} />
      <Route exact path="/crm/uon/create" component={UonCrm} />
      <Route exact path="/crm/uon/finish" component={UonCrmFinish} />
      <Route exact path="/crm/bitrix" component={Bitrix} />
      <Route exact path="/crm/bitrix/create" component={Bitrix} />
      <Route exact path="/crm/bitrix/finish" component={BitrixFinish} />
      <Route exact path="/crm/megaplan" component={MegaPlan} />
      <Route exact path="/crm/megaplan/create" component={MegaPlan} />
      <Route exact path="/crm/megaplan/finish" component={MegaPlanFinish} />
      <Route exact path="/crm/custom" component={CustomCrm} />
      <Route exact path="/crm/custom/create" component={CustomCrm} />
      <Route exact path="/crm/custom/finish" component={CustomCrmFinish} />
      <Route exact path="/crm/yclients" component={Yclients} />
      <Route exact path="/crm/yclients/create" component={Yclients} />
      <Route exact path="/crm/yclients/finish" component={YclientsFinish} />
      <Route path="/wizard/verify" component={Verify} />
      <Route path="/wizard/site" component={Site} />
      <Route path="/wizard/statistics" component={StatisticsPage} />
      <Route exact path="/wizard/ga" component={AddGa} />
      <Route
        path="/wizard/sources/google_abc/settings/:hash"
        component={GoogleAdsSetting}
      />
      <Route
        path="/sources/google_abc/settings/:hash"
        component={GoogleAdsSourceSetting}
      />
      <Route
        path="/sources/google_abc/confirm"
        component={GoogleAdsSourceConfirm}
      />
      <Route
        path="/wizard/sources/vkontakte/settings/:hash"
        component={VkontakteSetting}
      />
      <Route
        path="/sources/vkontakte/settings/:hash"
        component={VkontakteSourceSetting}
      />
      <Route
        path="/wizard/sources/yandex_market/settings/:hash"
        component={YandexMarketSetting}
      />
      <Route
        path="/sources/yandex_direct/settings/:hash"
        component={YandexDirectSourceSetting}
      />
      <Route
        path="/sources/yandex_market/settings/:hash"
        component={YandexMarketSourceSetting}
      />
      <Route
        path="/wizard/sources/yandex_direct/settings/:hash"
        component={YandexDirectSetting}
      />
      <Route
        path="/wizard/sources/mytarget/settings/:hash"
        component={MyTargetSetting}
      />
      <Route
        path="/sources/mytarget/settings/:hash"
        component={MyTargetSourceSetting}
      />
      <Route
        path="/wizard/sources/dinrem/settings/:hash"
        component={DinremSetting}
      />
      <Route
        path="/sources/dinrem/settings/:hash"
        component={DinremSourceSetting}
      />
      <Route
        path="/wizard/sources/criteo/settings/:hash"
        component={CriteoSetting}
      />
      <Route
        path="/sources/criteo/settings/:hash"
        component={CriteoSourceSetting}
      />
      <Route
        path="/wizard/sources/facebook/settings/:hash"
        component={FacebookSetting}
      />
      <Route
        path="/sources/facebook/settings/:hash"
        component={FacebookSourceSetting}
      />
      <Route path="/wizard/ga/settings" component={GaUser} />
      <Route path="/wizard/ga/dataset" component={DataSet} />
      <Route path="/wizard/ga/confirm" component={Confirm} />
      <Route path="/wizard/sources/sync" component={GAAsync} />
      <Route path="/wizard/sources/settings" component={SourceSetting} />

      <Route exact path="/ga/add" component={AddGa2} />
      <Route path="/ga/settings" component={GaUser2} />
      <Route path="/ga/dataset" component={DataSet2} />
      <Route path="/ga/confirm" component={Confirm2} />
      <Route path="/ga/sources/sync" component={GAAsync2} />

      <Route path="/wizard/crm/settings" component={CrmSetting} />
      <Route
        path="/wizard/calltracking/settings"
        component={CalltrackingSetting}
      />
      <Route exact path="/wizard/card" component={Card} />
      <Route exact path="/pay/verify" component={PayVerify} />
      <Route path="/wizard/card/complete" component={CardComplete} />
      <Route path="/wizard/complete" component={CardComplete} />
      <Route path="/card/fail" component={CardFail} />
      <Route path="/ecom" component={Ecom} />
      <Route path="/password/reset/:token" component={PassReset} />
      <Route path="/password/reset" component={EmailPass} />

      <Route path="/reports/:type" component={Report} />

      <Route path="/end-to-end" component={ReportEndToEndDemo} />
      <Route path="/daily" component={ReportDailyDemo} />

      <Route path="/referral" component={Referral} />
    </Switch>
  </div>
))

if (document.getElementById('app')) {
  ReactDOM.render(
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
        <Router>
          <MuiThemeProvider theme={muiTheme}>
            <SnackbarProvider
              maxSnack={10}
              classes={{
                variantError: 'serverError',
              }}
            >
              <App />
            </SnackbarProvider>
          </MuiThemeProvider>
        </Router>
      </Provider>
    </I18nextProvider>,
    document.getElementById('app')
  )
}
